module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img63.683117e6.jpg";